export default __webpack_public_path__ + "static/3-e222f245e97846d8512b9d4a435c3423.jpg";